import { CreationToolSourceFile } from 'site/creation-tools/types'
import styled from 'styled-components'

const VerticalPlayhead = styled.div`
    bottom: 0;
    box-sizing: border-box;
    left: 16px;
    padding: 3px 0;
    pointer-events: none;
    position: absolute;
    right: 16px;
    top: 0;
    z-index: 1;

    &:before {
        background: #fff;
        border-radius: 2px;
        box-shadow: 0 3px 8px rgba(0, 0, 0, 0.5);
        content: '';
        display: block;
        height: 100%;
        margin-left: -2px;
        width: 4px;
    }
`
type PlayheadProps = {
    source: CreationToolSourceFile
    playheadTime: number
}

const Playhead = ({ source, playheadTime }: PlayheadProps) => {
    return <VerticalPlayhead style={{ transform: `translate3d(${(playheadTime / source.duration) * 100}%, 0, 0)` }} />
}

export default Playhead
